import React, { useEffect, useState, useContext } from "react";
import appConst from "../Utilities/appConst.json";
import SummaryItemTils from "./SummaryItemTils";
import SummaryItemMosaic from "./SummaryItemMosaic";
import SummaryItemBook from "./SummaryItemBook";
import SummaryItemCalendars from "./SummaryItemCalendars";
import "../styles/summary.css";
import { useDispatch, useSelector } from "react-redux";
import { getUiItemFilterPrefix } from "../Utilities/itemFilter";

const SummaryBasketItems = (props) => {
  const product = sessionStorage.getItem(appConst.PRODUCT);
  const basketItems = useSelector((state) => state.basket.basketItems);
  const couponsItems = useSelector((state) => state.coupons.items);
  const direction = useSelector((state) => state.mode.direction);

  const isMosaic = (item) => {
    return item.format.toString().startsWith(appConst.MOSAIC_CODE);
  };

  return (
    <div className="summary_basket_items" data-testid="summary-basket-items-list">
      {basketItems.map((item) => (
        <React.Fragment key={item.item_id}>
          {product === appConst.TILES && !isMosaic(item) && (
            <SummaryItemTils
              item={item}
              couponsItem={couponsItems.find(
                (couponItem) => couponItem.item_id == item.item_id
              )}
              id={item.item_id}
              isChecked={item.isChecked}
              product={product}
            />
          )}
          {product === appConst.TILES && isMosaic(item) && (
            <SummaryItemMosaic
              item={item}
              couponsItem={couponsItems.find(
                (couponItem) => couponItem.item_id == item.item_id
              )}
              id={item.item_id}
              isChecked={item.isChecked}
              product={product}
            />
          )}
          {product === appConst.BOOKS &&
            (getUiItemFilterPrefix(item?.item_filter) === appConst.VERSION_CALENDAR_PREFIX ? (
              <SummaryItemCalendars
                item={item}
                couponsItem={couponsItems.find(
                  (couponItem) => couponItem.item_id == item.item_id
                )}
                id={item.item_id}
                isChecked={item.isChecked}
                product={product}
              />
            ) : (
              <SummaryItemBook
                item={item}
                couponsItem={couponsItems.find(
                  (couponItem) => couponItem.item_id == item.item_id
                )}
                id={item.item_id}
                isChecked={item.isChecked}
                product={product}
              />
            ))}
          {product === appConst.CALENDARS && (
            <SummaryItemCalendars
              item={item}
              couponsItem={couponsItems.find(
                (couponItem) => couponItem.item_id == item.item_id
              )}
              id={item.item_id}
              isChecked={item.isChecked}
              product={product}
            />
          )}
        </React.Fragment>
      ))}
      {product === appConst.TILES && (
        <div
          key={basketItems?.length + 1}
          className="summary_item_container "
          style={{ padding: "16px 16px 0", direction, textAlign: "start" }}
          data-testid="summary-basket-items-note"
        >
          *{props.note}
        </div>
      )}
    </div>
  );
};
export default SummaryBasketItems;
